const Dashboard = () => {
    return (
        <div>
            <h1>Dashboard</h1>
            <p>Welcome to the Admin Dashboard. Here, you can view real-time analytics and reports.</p>
        </div>
    );
};

export default Dashboard;
